"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import Formatter from "@/framework/timeformatter";
import AccountSeurityEditDeviceDialog from "@/views/safemanagements/MoreSafeManager/dialog/AccountSeurityEditDeviceDialog.vue";
let AccountSecurityAccess = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridSecurityController = new GridController(
      new APIDataSource("api://base.auth/api/v7/accounts/verify/device_list")
    );
    this.pin_security = false;
    this.formatter = Formatter;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getPinState();
    });
  }
  getPinState() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth/api/v7/accounts/pinState`
        );
        this.pin_security = response.data.account_pin_state;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  setPinState() {
    return __async(this, null, function* () {
      try {
        const response = yield API.put(
          `api://base.auth/api/v7/accounts/pinState`,
          {
            account_pin_state: this.pin_security
          }
        );
        this.$message.success(
          this.$t("accountseurity.modified_successfully")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  editServiceInfo(row) {
    return __async(this, null, function* () {
      this._accountSeurityEditDeviceDialog.open(row);
    });
  }
  deleteServiceInfo(row) {
    return __async(this, null, function* () {
      yield this.$confirm(
        this.$t("accountseurity.do_you_want_to_delete_this_device"),
        this.$t("accountseurity.tips"),
        {
          confirmButtonText: this.$t("accountseurity.delete"),
          cancelButtonText: this.$t("accountseurity.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        try {
          const response = yield API.delete(
            `api://base.auth/api/v7/accounts/delete/device/${row.guid}`
          );
          this.$message.success(
            this.$t("accountseurity.delete_successful")
          );
          this.refresh();
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).catch(() => {
        return;
      });
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridSecurityController.search();
    });
  }
};
__decorateClass([
  Ref("accountSeurityEditDeviceDialog")
], AccountSecurityAccess.prototype, "_accountSeurityEditDeviceDialog", 2);
AccountSecurityAccess = __decorateClass([
  Component({
    components: {
      UiGrid,
      AccountSeurityEditDeviceDialog
    }
  })
], AccountSecurityAccess);
export {
  AccountSecurityAccess as default
};
